import axios from "axios";
import { ContractAddress } from "../utils/Network";

// CLEG moved to ContractAddress on 2026-06-20. That contract minted 687,811,619
// CLEG once, and every burn lowers its totalSupply. CoinGecko only ever listed
// the previous contract, so it is not a source for this one.
export const CLEG_INITIAL_SUPPLY = 687811619;
const BSC_RPC_URL = "https://bsc-dataseed.binance.org/";
const TOTAL_SUPPLY_SELECTOR = "0x18160ddd";

// Third-party hosts: no session cookie, and no JWT from the axios interceptor.
const external = { notInterceptor: true, withCredentials: false, timeout: 15000 } as const;

type DexPair = {
  priceUsd?: string;
  liquidity?: { usd?: number };
  baseToken?: { address?: string };
};

// USD price of CLEG on its most liquid DEX pair.
export async function fetchClegPrice(): Promise<number | undefined> {
  const response = await axios.get<{ pairs?: DexPair[] | null }>(
    `https://api.dexscreener.com/latest/dex/tokens/${ContractAddress}`, external as any);
  const pairs = (response.data?.pairs || [])
    .filter(pair => pair.baseToken?.address?.toLowerCase() === ContractAddress.toLowerCase())
    .sort((a, b) => (b.liquidity?.usd || 0) - (a.liquidity?.usd || 0));
  const price = Number(pairs[0]?.priceUsd);
  return Number.isFinite(price) && price > 0 ? price : undefined;
}

export type ClegSupply = { minted: number; supply: number; burnt: number };

// CLEG on the current contract: what it minted, what still exists, and the
// difference, which is what has been burnt.
export async function fetchClegSupply(): Promise<ClegSupply | undefined> {
  const response = await axios.post<{ result?: string }>(BSC_RPC_URL, {
    jsonrpc: "2.0", id: 1, method: "eth_call",
    params: [{ to: ContractAddress, data: TOTAL_SUPPLY_SELECTOR }, "latest"],
  }, external as any);
  const result = response.data?.result;
  // 18 decimals; a double is exact enough for a whole-token display.
  const supply = result && result.length > 2 ? Number(result) / 1e18 : NaN;
  if (!Number.isFinite(supply) || supply <= 0) return undefined;
  return {
    minted: CLEG_INITIAL_SUPPLY,
    supply: Math.round(supply),
    burnt: Math.max(0, Math.round(CLEG_INITIAL_SUPPLY - supply)),
  };
}
